type FunctionLabelProps = {
  number: number
  status: string
  color: 'success' | 'warning' | 'danger' | 'disabled'
  progress?: [number, number] | [number, number, string]
  hover?: boolean
}

export default function ProjectLabel({
  number,
  status,
  color,
  progress,
  hover,
}: FunctionLabelProps) {
  const bgColor =
    color === 'success'
      ? 'tw-bg-success'
      : color === 'warning'
      ? 'tw-bg-secondary'
      : color === 'danger'
      ? 'tw-bg-danger'
      : color === 'disabled'
      ? 'tw-bg-system-grey-400'
      : ''
  const hoverColor = hover
    ? color === 'success'
      ? 'hover:tw-bg-success-900'
      : color === 'warning'
      ? 'hover:tw-bg-secondary-300'
      : color === 'danger'
      ? 'hover:tw-bg-danger-200'
      : color === 'disabled'
      ? 'hover:tw-bg-system-grey-600'
      : ''
    : ''
  return (
    <div
      className={`tw-flex tw-flex-col tw-items-center tw-uppercase tw-text-sm`}>
      <div
        className={`tw-text-white tw-font-bold tw-rounded tw-px-2 ${bgColor} ${hoverColor}`}>
        {number}
      </div>
      <div className="tw-text-system-grey-400 tw-text-tiny tw-font-condensed">
        {status}
      </div>
      {progress ? (
        <div
          className="tw-w-8 tw-bg-system-grey-200"
          title={`${progress[0]} / ${progress[1]}${
            progress[2] ? `\n${progress[2]}` : ''
          }`}>
          <div
            className="tw-h-1 tw-bg-primary"
            style={{
              width: `${(progress[0] / progress[1]) * 100}%`,
            }}
          />
        </div>
      ) : null}
    </div>
  )
}
